<template>
  <div class="locations content-container flex-column">
    <div class="content-wrap">
      <!-- Górny panel z menu -->
      <div class="d-flex users-section-container no-content">
        <div class="users-section"></div>
        <div class="content-wrap">
          <TopMenu />
        </div>
      </div>

      <!-- Widok formularza (dodawanie/edycja) -->
      <div v-if="mode === 'form'" class="d-flex users-section-container">
        <div class="users-section">
          <span>{{ editingId ? t('location-edit') : t('location-add') }}</span>
        </div>
        <div class="content-wrap">
          <LocationForm
            :key="editingId ?? 'new'"
            :location-id="editingId"
            :accuracy-classes="accuracyClasses"
            @saved="handleSaved"
            @cancel="mode = 'list'"
          />
        </div>
      </div>

      <!-- Widok listy -->
      <div v-else class="d-flex users-section-container">
        <div class="users-section">
          <span>{{ t('location-management') }}</span>
        </div>
        <div class="content-wrap">
          <div class="d-flex align-items-center justify-content-between location-list-header">
            <h3>{{ t('location-management').toUpperCase() }}</h3>
            <div class="search-bar">
              <span @click="openAdd" class="add-location-action" :title="t('location-add')">+</span>
            </div>
          </div>
          <LocationList ref="listRef" @edit="openEdit" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import TopMenu from "@/components/TopMenu.vue";
import LocationList from "@/components/locations/LocationList.vue";
import LocationForm from "@/components/locations/LocationForm.vue";
import LocationsService from "@/services/LocationsService";

const { t } = useI18n();

const mode = ref("list"); // 'list' | 'form'
const editingId = ref(null);
const accuracyClasses = ref([]);
const listRef = ref(null);

function openAdd() {
  editingId.value = null;
  mode.value = "form";
}

function openEdit(id) {
  editingId.value = id;
  mode.value = "form";
}

async function handleSaved() {
  mode.value = "list";
  // Po powrocie na listę wymuś jej odświeżenie.
  await Promise.resolve();
  listRef.value?.load?.();
}

onMounted(async () => {
  try {
    accuracyClasses.value = await LocationsService.getAccuracyClasses();
  } catch (error) {
    console.error("Nie udało się pobrać klas dokładności:", error);
    accuracyClasses.value = [];
  }
});
</script>

<style scoped>
/* Wypełnienie wysokości: kontener treści rozciąga się w pionie, dzięki czemu biały panel
   listy i lewy cień (sekcja z tłem) ciągną się do dołu — bez „urwanego” białego paska
   pod tabelą i bez przerwanego cienia po lewej. */
.locations.content-container {
  min-height: 100%;
}

.locations.content-container > .content-wrap {
  display: flex;
  flex-direction: column;
  flex: 1;
}

/* Ostatni kontener (widok listy lub formularza) wypełnia pozostałą wysokość. */
.locations .users-section-container:last-child {
  flex: 1 1 auto;
}

/* Prawa część panelu na biało — likwiduje szary pasek między końcem tabeli a dołem panelu. */
.locations .users-section-container:last-child > .content-wrap {
  background-color: white;
}

.users-section-container {
  width: 100%;
}

.location-list-header {
  padding-top: 0.5rem;
  background-color: white;
  border-bottom: 1px solid #ccc;
}

.users-section {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

.users-section > span {
  padding: 10px 25px;
  position: relative;
  display: block;
}

.content-wrap h3 {
  padding: 15px 25px;
  background-color: white;
}

.add-location-action {
  position: relative;
  top: -4px;
  cursor: pointer;
  font-size: 28px;
  margin-right: 1rem;
}
</style>
